import { useState } from 'react';
import { ShieldAlert, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface MFAGraceBannerProps {
  graceDaysRemaining: number;
  graceExpired: boolean;
  onSetupClick: () => void;
}

export function MFAGraceBanner({
  graceDaysRemaining,
  graceExpired,
  onSetupClick,
}: MFAGraceBannerProps) {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed && !graceExpired) {
    return null;
  }

  return (
    <div
      className={cn(
        'fixed top-0 inset-x-0 z-50 px-4 py-2 flex items-center justify-center gap-3 text-sm text-white',
        graceExpired
          ? 'bg-red-600 dark:bg-red-700'
          : 'bg-amber-500 dark:bg-amber-600'
      )}
      role="alert"
    >
      <ShieldAlert className="h-4 w-4 shrink-0" />
      <span>
        {graceExpired
          ? 'Die Frist für die Zwei-Faktor-Authentifizierung ist abgelaufen.'
          : `Bitte richten Sie die Zwei-Faktor-Authentifizierung ein. Noch ${graceDaysRemaining} ${graceDaysRemaining === 1 ? 'Tag' : 'Tage'} verbleibend.`}
      </span>
      <Button
        variant="outline"
        size="sm"
        className="h-7 border-white/40 bg-white/10 text-white hover:bg-white/20 hover:text-white"
        onClick={onSetupClick}
      >
        Jetzt einrichten
      </Button>
      {!graceExpired && (
        <button
          onClick={() => setDismissed(true)}
          className="ml-1 shrink-0 rounded p-0.5 hover:bg-white/20"
          aria-label="Banner schließen"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
